export default __webpack_public_path__ + "img/f29cf0a12b146e829738f0d691df7069.svg";